import type { OrgTipo } from './navigation';

/** Roles de personal asignables según rubro clínico (no hospital). */
export function assignableRolesForOrg(org: OrgTipo | string | null | undefined): string[] {
  const base = ['admin-tenant', 'recepcion', 'medico', 'caja', 'auditoria'];
  switch (org) {
    case 'clinica-veterinaria':
      return ['admin-tenant', 'vet-medico', 'vet-recepcion', 'vet-farmacia', 'caja', 'auditoria'];
    case 'clinica-optica':
      return ['admin-tenant', 'optica-optometrista', 'optica-recepcion', 'optica-ventas', 'recepcion', 'caja', 'auditoria'];
    case 'clinica-medica':
      return [...base, 'farmacia', 'laboratorio', 'imagenologia'];
    case 'clinica-odontologica':
    case 'clinica-estetica':
      return [...base, 'farmacia'];
    case 'clinica-nutricion':
    case 'clinica-psicologia':
    case 'clinica-fisioterapia':
      return base;
    case 'hospital-privado':
    case 'private-hospital':
      return [
        'admin-tenant', 'recepcion', 'medico', 'enfermeria', 'farmacia', 'laboratorio',
        'imagenologia', 'quirofano', 'caja', 'tesoreria', 'bodega', 'contabilidad', 'nomina',
        'mspas', 'auditoria', 'consultorio-externo',
      ];
    default:
      return base;
  }
}

export function filterAssignableRoles(all: string[], org: OrgTipo | string | null | undefined): string[] {
  const allowed = new Set(assignableRolesForOrg(org));
  return all.filter(r => allowed.has(r));
}
